export default {
    "area": [
        {
            "id": 0,
            "prov": "大连市内",
            "express": 14,
            "next": 12
        },
        {
            "id": 1,
            "prov": "北京",
            "express": 12,
            "next": 8
        },
        {
            "id": 2,
            "prov": "天津",
            "express": 12,
            "next": 8
        },     
        {
            "id": 3,
            "prov": "上海",
            "express": 8,
            "next": 3
        },   
        {
            "id": 4,
            "prov": "重庆",
            "express": 14,
            "next": 12
        },
        {
            "id": 5,
            "prov": "辽宁",
            "express": 14,
            "next": 12
        },
        {
            "id": 6,
            "prov": "黑龙江",
            "express": 14,
            "next": 12
        },
        {
            "id": 7,
            "prov": "吉林",
            "express": 14,
            "next": 12
        },
        {
            "id": 8,
            "prov": "河北",
            "express": 14,
            "next": 10
        },  
        {
            "id": 9,
            "prov": "山西",
            "express": 14,
            "next": 12
        },
        {
            "id": 10,
            "prov": "内蒙古",
            "express": 18,
            "next": 16
        },
        {
            "id": 11,
            "prov": "浙江",
            "express": 8,
            "next": 3
        },      
        {
            "id": 12,
            "prov": "江苏",
            "express": 8,
            "next": 3
        },
        {
            "id": 13,
            "prov": "安徽",
            "express": 10,
            "next": 5
        },
        {
            "id": 14,
            "prov": "山东",
            "express": 12,
            "next": 8
        },
        {
            "id": 15,
            "prov": "江西",
            "express": 14,
            "next": 12
        },
        {
            "id": 16,
            "prov": "福建",
            "express": 14,
            "next": 10
        },
        {
            "id": 17,
            "prov": "湖南",
            "express": 14,
            "next": 10
        },
        {
            "id": 18,
            "prov": "湖北",
            "express": 14,
            "next": 10
        },
        {
            "id": 19,
            "prov": "河南",
            "express": 14,
            "next": 10
        },
        {
            "id": 20,
            "prov": "广东",
            "express": 12,
            "next": 8
        },
        {
            "id": 21,
            "prov": "广西",
            "express": 14,
            "next": 12
        },
        {
            "id": 22,
            "prov": "海南",
            "express": 14,
            "next": 12
        },
        {
            "id": 23,
            "prov": "贵州",
            "express": 14,
            "next": 12
        },
        {
            "id": 24,
            "prov": "四川",
            "express": 14,
            "next": 12
        },
        {
            "id": 25,
            "prov": "云南",
            "express": 14,
            "next": 12
        },
        {
            "id": 26,
            "prov": "西藏",
            "express": 18,
            "next": 16
        },
        {
            "id": 27,
            "prov": "陕西",
            "express": 14,
            "next": 12
        },
        {
            "id": 28,
            "prov": "青海",
            "express": 18,
            "next": 16
        },
        {
            "id": 29,
            "prov": "甘肃",
            "express": 14,
            "next": 12
        },
        {
            "id": 30,
            "prov": "新疆",
            "express": 18,
            "next": 16
        },
        {
            "id": 31,
            "prov": "宁夏",
            "express": 14,
            "next": 12
        }
    ],
    "weight": "0.25"
}